import Vue from "vue";
import { Component, Emit, Prop } from "vue-property-decorator";

@Component({
    name: 'Edit',
    components: {
    }
})
export default class Edit extends Vue {
    @Prop({ required: true })
    data!: { id: number, name: string };

    mounted(): void {
    }

    @Emit('save')
    save(): void {

    }
}